<ng-select
  [items]="result_list"
  bindLabel="name"
  bindValue="_id"
  (change)="onSelection($event)"
  [(ngModel)]="selected_ids"
  [searchable]="true"
  [placeholder]="placeholder"
  [typeahead]="input$"
  [ngStyle]="getStyle(style)">
</ng-select>
